import http from '../http'

/**
 * 获取租户管理员设备
 * @returns {AxiosPromise}
 */
export function getAdminDevice() {
  return http({
    url: 'api/tenant/devices?limit=10000',
    method: 'get'
  })
}

/**
 * 获取普通租户设备
 * @param customerId
 * @returns {AxiosPromise}
 */
export function getCustomerDevice(customerId) {
  return http({
    url: '/api/customer/' + customerId + '/' + 'devices?limit=1000',
    method: 'get'
  })
}

/**
 * 获取设备类型以及Id
 * @param entityId
 * @returns {AxiosPromise}
 */
export function getCredentials(entityId) {
  return http({
    url: '/api/device/' + entityId + '/credentials',
    method: 'get'
  })
}

/**
 * 获取遥测数据的key值
 * get方法，对应get请求
 * @param entityType
 * @param id
 * @returns {AxiosPromise}
 */
export function getDeviceKey(entityType, id) {
  return http({
    url:  '/api/plugins/telemetry/' + entityType + '/' + id + '/keys/timeseries',
    method: 'get'
  })
}

/**
 * 获取最新遥测数据
 * get方法，对应get请求
 * @returns {AxiosPromise}
 */
export function getDeviceValue(entityType, id, key) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + id + '/values/timeseries?keys=' + key,
    method: 'get'
  })
}

/**
 * 获取历史数据
 * @param entityType
 * @param id
 * @param key
 * @param start
 * @param end
 * @param interval
 * @param agg
 * @returns {AxiosPromise}
 */
export function getTimeDeviceHistory(entityType, id, key, start, end, interval, agg) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + id + '/values/timeseries?keys=' + key + '&startTs=' + start + '&endTs=' + end + '&interval=' + interval + '&limit=1440&agg=' + agg,
    method: 'get'
  })
}

/**
 * 获取客户端数值
 * @param access
 * @returns {AxiosPromise}
 */
export function getAttributesClient(access) {
  return http({
    url: '/api/v1/' + access + '/attributes',
    method: 'get'
  })
}

/**
 * 向客户端传值
 * @param access
 * @param param
 * @returns {AxiosPromise}
 */
export function postClientInfo(access,param) {
  return http({
    url: '/api/v1/' + access + '/attributes',
    method: 'post',
    data: param
  })
}

/**
 * 获取共享端数据
 * @param entityType
 * @param deviceId
 * @returns {AxiosPromise}
 */
export function getAttributesShared(entityType, deviceId) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + deviceId + '/values/attributes/SHARED_SCOPE',
    method: 'get'
  })
}

/**
 * 获取服务端数据
 * @param entityType
 * @param deviceId
 * @returns {AxiosPromise}
 */
export function getAttributesServer(entityType, deviceId) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + deviceId + '/values/attributes/SERVER_SCOPE',
    method: 'get'
  })
}

/**
 * 获取最后一次连接数据
 * @param entityType
 * @param deviceId
 * @returns {AxiosPromise}
 */
export function getConnectTime(entityType, deviceId) {
  return http({
    url: '/api/plugins/telemetry/'+ entityType + '/' + deviceId + '/values/attributes/SERVER_SCOPE?keys=lastActivityTime',
    method: 'get'
  })
}

/**
 * 获取指定设备信息
 * @param deviceId
 * @returns {AxiosPromise}
 */

export function getDeviceName(deviceId) {
  return http({
    url: '/api/device/' + deviceId,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/untils/api/home.js